<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-market-quotations`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42 4a2 2 0 012 2v36a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h36zm-2 4H8v32h32V8zm-6.954 9.99l1.414 1.414a1 1 0 010 1.414l-7.778 7.778a1 1 0 01-1.327.078l-.087-.078-4.243-4.242-5.657 5.656a1 1 0 01-1.414 0l-1.414-1.414a1 1 0 010-1.414l7.778-7.778a1 1 0 011.414 0l4.243 4.242 5.657-5.656a1 1 0 011.414 0z"/></svg>
</template>
<script>

export default {
  name: 'IconMarketQuotations',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
